import React from "react";
import { useSelector } from "react-redux";
import { Loader } from "../../../UI/Loader/Loader";
import { DashboardRouter } from "../../../../routs/DashboardRouter";
import { selectAuthLoader } from "../../../../model/system/selectors";

export type typeSetSidebarOpen = {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Dashboard: React.FC<typeSetSidebarOpen> = ({ setSidebarOpen }) => {
  const loader = useSelector(selectAuthLoader);

  return (
    <div className="flex flex-col w-0 flex-1 overflow-hidden right-side">
      <main className="flex-1 relative z-0 overflow-x-auto focus:outline-none">
        <div className="relative min-h-full py-3 px-3 sm:py-6 sm:px-6">
          <DashboardRouter setSidebarOpen={setSidebarOpen} />

          {loader ? <Loader /> : null}
        </div>
      </main>
    </div>
  );
};
